// import React, { useState, useEffect } from 'react';
// import {
//   ThemeProvider,
//   createTheme,
//   Box,
//   Typography,
//   Container,
//   CssBaseline,
//   Button,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import * as XLSX from 'xlsx';
// import axios from 'axios';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#000000',
//     },
//     secondary: {
//       main: '#dc004e',
//     },
//   },
//   typography: {
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//   },
// });

// function StartUps() {
//   const [rows, setRows] = useState([]);
//   const [filteredRows, setFilteredRows] = useState([]);
//   const [filters, setFilters] = useState({
//     institution: '',
//     field_of_study: '',
//     graduation_year: '',
//     status: '',
//   });
//   const [filterOptions, setFilterOptions] = useState({
//     institutions: [],
//     fieldsOfStudy: [],
//     graduationYears: [],
//     statuses: [],
//   });
//   const [pageSize, setPageSize] = useState(10);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [selectedParticipants, setSelectedParticipants] = useState([]);
//   const [action, setAction] = useState('');

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         'https://puneexpobackend.tdtlworld.com/api/verified_students/'
//       );
//       const formattedData = response.data
//         .filter((item) => item.admin_approval === false)
//         .map((item, index) => ({
//           id: item.student_id, // Use student_id as the unique identifier
//           serial_number: index + 1, // Add serial number for display purposes
//           ...item,
//         }));

//       const institutions = [...new Set(formattedData.map((item) => item.institution))];
//       const fieldsOfStudy = [...new Set(formattedData.map((item) => item.field_of_study))];
//       const graduationYears = [...new Set(formattedData.map((item) => item.graduation_year))];
//       const statuses = [...new Set(formattedData.map((item) => item.status || ''))];

//       setRows(formattedData);
//       setFilteredRows(formattedData);
//       setFilterOptions({
//         institutions,
//         fieldsOfStudy,
//         graduationYears,
//         statuses,
//       });
//       setLoading(false);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       setSnackbarMessage('Error fetching data. Please try again.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//       setLoading(false);
//     }
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   useEffect(() => {
//     const applyFilters = () => {
//       let filtered = rows;
//       Object.entries(filters).forEach(([key, value]) => {
//         if (value) {
//           filtered = filtered.filter((row) => row[key]?.toString() === value.toString());
//         }
//       });
//       setFilteredRows(filtered);
//     };

//     applyFilters();
//   }, [filters, rows]);

//   const handleAction = (actionType) => {
//     if (selectedParticipants.length === 0) {
//       setSnackbarMessage('Please select at least one participant.');
//       setSnackbarSeverity('warning');
//       setSnackbarOpen(true);
//       return;
//     }
//     setAction(actionType);
//     setDialogOpen(true);
//   };

//   const handleConfirmAction = async () => {
//     try {
//       const endpoint = 'https://puneexpobackend.tdtlworld.com/api/students_approval/';
//       const payload = {
//         student_id: selectedParticipants.map((participant) => participant.id),
//         status: action,
//       };

//       const response = await axios.patch(endpoint, payload);

//       if (response.status === 200) {
//         const updatedRows = rows.map((row) => {
//           if (selectedParticipants.some((participant) => participant.id === row.id)) {
//             return { ...row, status: action };
//           }
//           return row;
//         });

//         setRows(updatedRows);
//         setFilteredRows(updatedRows);
//         setDialogOpen(false);

//         setSnackbarMessage(response.data.msg || 'Student status updated successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         setSelectedParticipants([]);
//       } else {
//         throw new Error('Unexpected response status');
//       }
//     } catch (error) {
//       console.error('Error updating student status:', error);
//       setSnackbarMessage('Error updating student status. Please try again.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     }
//   };

//   const handleDownloadExcel = () => {
//     const worksheet = XLSX.utils.json_to_sheet(filteredRows);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Students');
//     XLSX.writeFile(workbook, 'Verified_Students.xlsx');
//   };

//   const handleIndividualAction = async (row, actionType) => {
//     try {
//       const endpoint = 'https://puneexpobackend.tdtlworld.com/api/students_approval/';
//       const payload = {
//         student_id: [row.id],
//         status: actionType,
//       };

//       const response = await axios.patch(endpoint, payload);

//       if (response.status === 200) {
//         const updatedRows = rows.map((r) =>
//           r.id === row.id ? { ...r, status: actionType } : r
//         );

//         setRows(updatedRows);
//         setFilteredRows(updatedRows);

//         setSnackbarMessage(response.data.msg || `Student ${actionType} successfully.`);
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//       } else {
//         throw new Error('Unexpected response status');
//       }
//     } catch (error) {
//       console.error(`Error ${actionType}ing student:`, error);
//       setSnackbarMessage(`Error ${actionType}ing student. Please try again.`);
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     }
//   };

//   const columns = [
//     { field: 'serial_number', headerName: 'S.No.', width: 100 },
//     // { field: 'student_id', headerName: 'Student ID', width: 150 },
//     { field: 'full_name', headerName: 'Full Name', flex: 1, minWidth: 150 },
//     { field: 'email', headerName: 'Email', flex: 1, minWidth: 200 },
//     { field: 'phone_number', headerName: 'Phone Number', flex: 1, minWidth: 150 },
//     { field: 'institution', headerName: 'Institution', flex: 1, minWidth: 150 },
//     { field: 'field_of_study', headerName: 'Field of Study', flex: 1, minWidth: 150 },
//     { field: 'graduation_year', headerName: 'Graduation Year', flex: 1, minWidth: 120 },
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       width: 200,
//       renderCell: (params) => (
//         <Box sx={{ display: 'flex', gap: 1 }}>
//           <Button
//             variant="outlined"
//             color="primary"
//             size="small"
//             onClick={() => handleIndividualAction(params.row, 'accept')}
//           >
//             Accept
//           </Button>
//           <Button
//             variant="outlined"
//             color="secondary"
//             size="small"
//             onClick={() => handleIndividualAction(params.row, 'denied')}
//           >
//             Deny
//           </Button>
//         </Box>
//       ),
//     },
//     { field: 'status', headerName: 'Status', flex: 1, minWidth: 120 },
   
//   ];

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
//         <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold', color: '#37474f' }}>
//           Verified Students Dashboard
//         </Typography>
//         <Box
//           sx={{
//             display: 'flex',
//             flexWrap: 'wrap',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             mb: 2,
//           }}
//         >
//           <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
//             <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//               <InputLabel>Institution</InputLabel>
//               <Select
//                 name="institution"
//                 value={filters.institution}
//                 onChange={handleFilterChange}
//                 label="Institution"
//               >
//                 <MenuItem value="">All</MenuItem>
//                 {filterOptions.institutions.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//               <InputLabel>Field of Study</InputLabel>
//               <Select
//                 name="field_of_study"
//                 value={filters.field_of_study}
//                 onChange={handleFilterChange}
//                 label="Field of Study"
//               >
//                 <MenuItem value="">All</MenuItem>
//                 {filterOptions.fieldsOfStudy.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//               <InputLabel>Graduation Year</InputLabel>
//               <Select
//                 name="graduation_year"
//                 value={filters.graduation_year}
//                 onChange={handleFilterChange}
//                 label="Graduation Year"
//               >
//                 <MenuItem value="">All</MenuItem>
//                 {filterOptions.graduationYears.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//               <InputLabel>Status</InputLabel>
//               <Select
//                 name="status"
//                 value={filters.status}
//                 onChange={handleFilterChange}
//                 label="Status"
//               >
//                 <MenuItem value="">All</MenuItem>
//                 {filterOptions.statuses.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Box>
//           <Button variant="contained" color="primary" onClick={handleDownloadExcel}>
//             Download Excel
//           </Button>
//         </Box>
//         <Box sx={{ height: 600, width: '100%' }}>
//           {loading ? (
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 height: '100%',
//               }}
//             >
//               <CircularProgress />
//             </Box>
//           ) : (
//             <DataGrid
//               rows={filteredRows}
//               columns={columns}
//               // checkboxSelection
//               onSelectionModelChange={(newSelection) => {
//                 const selected = newSelection.map((id) =>
//                   filteredRows.find((row) => row.id === id)
//                 );
//                 setSelectedParticipants(selected.filter(Boolean));
//               }}
//               pageSize={pageSize}
//               onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
//               rowsPerPageOptions={[5, 10, 20]}
//               pagination
//             />
//           )}
//         </Box>
//         <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={() => handleAction('accept')}
//           >
//             Accept Selected
//           </Button>
//           <Button
//             variant="contained"
//             color="secondary"
//             onClick={() => handleAction('denied')}
//           >
//             Deny Selected
//           </Button>
//         </Box>
//       </Container>
//       <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
//         <DialogTitle>{`Confirm ${action === 'accept' ? 'Acceptance' : 'Denial'}`}</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to {action} the selected participants?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
//           <Button onClick={handleConfirmAction} autoFocus>
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: '100%' }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </ThemeProvider>
//   );
// }

// export default StartUps;
import React, { useState, useEffect } from 'react';
import {
  ThemeProvider,
  createTheme,
  Box,
  Typography,
  Container,
  CssBaseline,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import * as XLSX from 'xlsx';
import axios from 'axios';

const theme = createTheme({
  palette: {
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function StartUps() {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [filters, setFilters] = useState({
    institution: '',
    field_of_study: '',
    graduation_year: '',
    status: '',
  });
  const [filterOptions, setFilterOptions] = useState({
    institutions: [],
    fieldsOfStudy: [],
    graduationYears: [],
    statuses: [],
  });
  const [pageSize, setPageSize] = useState(10);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedParticipants, setSelectedParticipants] = useState([]);
  const [action, setAction] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        'https://puneexpobackend.tdtlworld.com/api/verified_students/'
      );
      const formattedData = response.data
        .filter(
          (item) =>
           
            (!item.institution || item.institution.trim() === '')
        )
        .map((item, index) => ({
          id: item.student_id,
          serial_number: index + 1,
          ...item,
        }));

      const institutions = [...new Set(formattedData.map((item) => item.institution))];
      const fieldsOfStudy = [...new Set(formattedData.map((item) => item.field_of_study))];
      const graduationYears = [...new Set(formattedData.map((item) => item.graduation_year))];
      const statuses = [...new Set(formattedData.map((item) => item.status || ''))];

      setRows(formattedData);
      setFilteredRows(formattedData);
      setFilterOptions({
        institutions,
        fieldsOfStudy,
        graduationYears,
        statuses,
      });
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setSnackbarMessage('Error fetching data. Please try again.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const applyFilters = () => {
      let filtered = rows;
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          filtered = filtered.filter((row) => row[key]?.toString() === value.toString());
        }
      });
      setFilteredRows(filtered);
    };

    applyFilters();
  }, [filters, rows]);

  const handleAction = (actionType) => {
    if (selectedParticipants.length === 0) {
      setSnackbarMessage('Please select at least one participant.');
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
      return;
    }
    setAction(actionType);
    setDialogOpen(true);
  };

  const handleConfirmAction = async () => {
    try {
      const endpoint = 'https://puneexpobackend.tdtlworld.com/api/students_approval/';
      const payload = {
        student_id: selectedParticipants.map((participant) => participant.id),
        status: action,
      };

      const response = await axios.patch(endpoint, payload);

      if (response.status === 200) {
        const updatedRows = rows.map((row) => {
          if (selectedParticipants.some((participant) => participant.id === row.id)) {
            return { ...row, status: action };
          }
          return row;
        });

        setRows(updatedRows);
        setFilteredRows(updatedRows);
        setDialogOpen(false);

        setSnackbarMessage(response.data.msg || 'Student status updated successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setSelectedParticipants([]);
      } else {
        throw new Error('Unexpected response status');
      }
    } catch (error) {
      console.error('Error updating student status:', error);
      setSnackbarMessage('Error updating student status. Please try again.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

//   const handleDownloadExcel = () => {
//     const exportData = filteredRows.map((row) => ({
//       'S.No.': row.serial_number,
//       'Full Name': row.full_name,
//       'Email': row.email,
//       'Phone Number': row.phone_number,
//     }));
  
//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Students');
//     XLSX.writeFile(workbook, 'Verified_Students.xlsx');
//   };
const handleDownloadExcel = () => {
    const exportData = filteredRows.map((row) => [
      row.serial_number,
      row.full_name,
      row.email,
      row.phone_number,
    ]);
  
    // Add headers
    const header = [['S.No.', 'Full Name', 'Email', 'Phone Number']];
  
    // Combine header and data
    const worksheetData = [...header, ...exportData];
  
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  
    // Add basic styling: set column widths
    const wscols = [
      { wch: 10 }, // S.No.
      { wch: 30 }, // Full Name
      { wch: 40 }, // Email
      { wch: 20 }, // Phone Number
    ];
    worksheet['!cols'] = wscols;
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Students');
  
    XLSX.writeFile(workbook, 'StartUps Register.xlsx');
  };
  
  
  const handleIndividualAction = async (row, actionType) => {
    try {
      const endpoint = 'https://puneexpobackend.tdtlworld.com/api/students_approval/';
      const payload = {
        student_id: [row.id],
        status: actionType,
      };

      const response = await axios.patch(endpoint, payload);

      if (response.status === 200) {
        const updatedRows = rows.map((r) =>
          r.id === row.id ? { ...r, status: actionType } : r
        );

        setRows(updatedRows);
        setFilteredRows(updatedRows);

        setSnackbarMessage(response.data.msg || `Student ${actionType} successfully.`);
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
      } else {
        throw new Error('Unexpected response status');
      }
    } catch (error) {
      console.error(`Error ${actionType}ing student:`, error);
      setSnackbarMessage(`Error ${actionType}ing student. Please try again.`);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const columns = [
    { field: 'serial_number', headerName: 'S.No.', width: 100 },
    { field: 'full_name', headerName: 'Full Name', flex: 1, minWidth: 150 },
    { field: 'email', headerName: 'Email', flex: 1, minWidth: 200 },
    { field: 'phone_number', headerName: 'Phone Number', flex: 1, minWidth: 150 },
    // { field: 'institution', headerName: 'Institution', flex: 1, minWidth: 150 },
    // { field: 'field_of_study', headerName: 'Field of Study', flex: 1, minWidth: 150 },
    // { field: 'graduation_year', headerName: 'Graduation Year', flex: 1, minWidth: 120 },
    // {
    //   field: 'actions',
    //   headerName: 'Actions',
    //   width: 200,
    //   renderCell: (params) => (
    //     <Box sx={{ display: 'flex', gap: 1 }}>
    //       <Button
    //         variant="outlined"
    //         color="primary"
    //         size="small"
    //         onClick={() => handleIndividualAction(params.row, 'accept')}
    //       >
    //         Accept
    //       </Button>
    //       <Button
    //         variant="outlined"
    //         color="secondary"
    //         size="small"
    //         onClick={() => handleIndividualAction(params.row, 'denied')}
    //       >
    //         Deny
    //       </Button>
    //     </Box>
    //   ),
    // },
    // { field: 'status', headerName: 'Status', flex: 1, minWidth: 120 },
  ];

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="lg" sx={{ mt: 10, mb: 4 }}>
        <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold', color: '#37474f' }}>
         StartUp List
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Institution</InputLabel>
              <Select
                name="institution"
                value={filters.institution}
                onChange={handleFilterChange}
                label="Institution"
              >
                <MenuItem value="">All</MenuItem>
                {filterOptions.institutions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Field of Study</InputLabel>
              <Select
                name="field_of_study"
                value={filters.field_of_study}
                onChange={handleFilterChange}
                label="Field of Study"
              >
                <MenuItem value="">All</MenuItem>
                {filterOptions.fieldsOfStudy.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Graduation Year</InputLabel>
              <Select
                name="graduation_year"
                value={filters.graduation_year}
                onChange={handleFilterChange}
                label="Graduation Year"
              >
                <MenuItem value="">All</MenuItem>
                {filterOptions.graduationYears.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Status</InputLabel>
              <Select
                name="status"
                value={filters.status}
                onChange={handleFilterChange}
                label="Status"
              >
                <MenuItem value="">All</MenuItem>
                {filterOptions.statuses.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Button variant="contained" color="primary" onClick={handleDownloadExcel}>
            Download Excel
          </Button>
        </Box>
        <Box sx={{ height: 600, width: '100%' }}>
          {loading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <DataGrid
              rows={filteredRows}
              columns={columns}
              onSelectionModelChange={(newSelection) => {
                const selected = newSelection.map((id) =>
                  filteredRows.find((row) => row.id === id)
                );
                setSelectedParticipants(selected.filter(Boolean));
              }}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[5, 10, 20]}
              pagination
            />
          )}
        </Box>
        {/* <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleAction('accept')}
          >
            Accept Selected
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => handleAction('denied')}
          >
            Deny Selected
          </Button>
        </Box> */}
      </Container>
      {/* <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>{`Confirm ${action === 'accept' ? 'Acceptance' : 'Denial'}`}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to {action} the selected participants?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleConfirmAction} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog> */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
}

export default StartUps;
